// 서버가 준 링크를 그대로 router 에 넘기면 `//host` 같은 값에서 history.pushState 가
// SecurityError 를 던진다 — 앱 내부 절대 경로만 통과시킨다
export const isInAppPath = (link?: string): boolean =>
  !!link && link.startsWith('/') && !link.startsWith('//')
